import { temp } from 'three/examples/jsm/nodes/Nodes.js';
import { useSnapshot } from 'valtio';

import Checkbox from '@cartwhl/ui/atoms/Checkbox';
import Button from '@cartwhl/ui/input/Button';

import { HelpMenu } from 'components/StudioLayout';
import { posingStore, projectStore } from 'stores';

export default function Footer() {
  // #region DATA
  const { posingSystem } = useSnapshot(posingStore.state);
  const { showSkeletonHelper } = useSnapshot(posingStore.state);

  // #endregion

  // #region HANDLERS
  const handleResetPose = async () => {
    posingSystem.current?.poser.resetPose();
    await new Promise((resolve) => setTimeout(resolve, 100));
    const canvasImageTaskURL = await posingSystem.current?.canvasImageTask();
    const canvasBase64 = canvasImageTaskURL?.replace(
      /^data:image\/\w+;base64,/,
      '',
    );
    posingStore.setLastCanvasBase64(canvasBase64 || '');
    await projectStore.createOrUpdatePoseObject(canvasBase64);
  };

  const handleSkeleton = (v: boolean) => {
    posingStore.state.showSkeletonHelper = v;
  };
  // #endregion

  return (
    <div className="mx-6 flex h-16 items-center gap-2">
      <div className="hidden flex-1 items-center gap-4 sm:flex">
        <Checkbox
          id="footer-skeleton-checkbox"
          checked={showSkeletonHelper}
          setChecked={(checked) => handleSkeleton(checked)}
          label="Show skeleton"
          variant="checkbox"
          color="settings"
        />
      </div>

      <div className="flex flex-none gap-2">
        <Button variant="secondary" size="sm" onClick={handleResetPose}>
          Back to default pose
        </Button>
      </div>

      <div className="flex flex-1 items-center justify-end">
        <HelpMenu />
      </div>
    </div>
  );
}
